import { type FC } from "react";
import { Navigate } from "react-router-dom";

import { useFeatureGates } from "../../cof-feature-gates/hooks";
import { CofConfigId } from "../../gql-generated/types";
import { ListContainer } from "../../layout/components";
import { LensAutomationToolAlert } from "../../shared/components/LensAutomationToolAlert";
import { usePageRedirect } from "../../shared/hooks";
import { Feature } from "../../shared/models";
import { useLensManagementPageOpenBlizzardEvent } from "../hooks";

import { LensListPageHeight } from "./LensesPage.styles";
import { LensesPageTabs } from "./LensesPageTabs";
import { LensesList, lensesListStyles } from "./list";
import { PageOrganizationHeader, PageOrganizationHeaderV3 } from "./list/header";

export const LensesPageV3: FC = () => {
    const redirect = usePageRedirect(Feature.lenses);

    useLensManagementPageOpenBlizzardEvent();
    const { configs } = useFeatureGates();

    if (redirect) {
        return <Navigate to={redirect} />;
    }
    const newUXenabled = configs[CofConfigId.MyLensesUxImprovements].enabled;

    return (
        <>
            <LensAutomationToolAlert />
            <ListContainer className={lensesListStyles}>
                {newUXenabled ? <PageOrganizationHeader /> : <PageOrganizationHeaderV3 />}
                {newUXenabled ? (
                    <LensesPageTabs />
                ) : (
                    <LensListPageHeight>
                        <LensesList />
                    </LensListPageHeight>
                )}
            </ListContainer>
        </>
    );
};
